import { Errors } from 'gleblu-socket-api';
import { createAction } from 'redux-act';

import PlaceUser from '../../../models/interfaces/PlaceUser';

export interface RegisterEmployeePayload {
  token: string;
  placeUser: PlaceUser;
  password: string;
}
export const registerEmployee = createAction<RegisterEmployeePayload>('REGISTER_EMPLOYEE');

export interface EmployeeRegistrationCompletedPayload {
  token: string;
  placeUser: PlaceUser;
}
export const employeeRegistrationCompleted = createAction<EmployeeRegistrationCompletedPayload>('EMPLOYEE_REGISTRATION_COMPLETED');

export interface EmployeeRegistrationFailedPayload {
  token: string;
  errorType?: Errors;
}
export const employeeRegistrationFailed = createAction<EmployeeRegistrationFailedPayload>('EMPLOYEE_REGISTRATION_FAILED');
